import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-117883d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "red-text" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Klik op een regel voor meer informatie.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Afgelopen week", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Actieve bronhouders", -1))
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { role: "presentation" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Aantal registraties", -1))
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { role: "presentation" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Waarvan GLD", -1))
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"padding-top":"20px"} }, "Op de landkaart", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Gemeenten", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { role: "presentation" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Provincies", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { role: "presentation" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Waterschappen", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "En verder", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Top-20", -1))
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { role: "presentation" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Trends", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Trends per gegevenstype in de BRO.", -1))
const _hoisted_26 = { id: "select-trends-wrapper" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "select-trends" }, "Selecteer een ander type:", -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { role: "presentation" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Stand", -1))
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { role: "presentation" }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Actualiteit van de gegevens", -1))
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { role: "presentation" }, null, -1))
const _hoisted_38 = { class: "row justify-center" }
const _hoisted_39 = ["src"]
const _hoisted_40 = {
  key: 1,
  class: "bromonitor row"
}
const _hoisted_41 = {
  class: "text-primary",
  id: "bromonitor-navigation"
}
const _hoisted_42 = {
  key: 1,
  class: "archive-link-inactive"
}
const _hoisted_43 = {
  key: 3,
  class: "archive-link-inactive"
}
const _hoisted_44 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_base_map_svg = _resolveComponent("base-map-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_spinner, { loaded: _ctx.loaded }, null, 8, ["loaded"]),
      (
      _ctx.loaded &&
      !_ctx.urlContainsDate() &&
      _ctx.model &&
      'static_data' in _ctx.model &&
      Object(_ctx.model).hasOwnProperty('static_data') &&
      Object.keys(_ctx.model.static_data).length > 0
    )
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
          }, [
            _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.model && "static_data" in _ctx.model && _ctx.model.static_data["datumstempel"]), 1),
            _hoisted_2,
            _createVNode(_component_q_separator, { class: "divider" }),
            _hoisted_3,
            _createVNode(_component_q_expansion_item, {
              id: "expansion-item-actieve-bronhouders",
              dense: "",
              modelValue: _ctx.actieveBronhoudersExpanded,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.actieveBronhoudersExpanded) = $event))
            }, {
              header: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  avatar: "",
                  role: "button",
                  "aria-expanded": _ctx.actieveBronhoudersExpanded.toString(),
                  "aria-label": "Open"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "timeline",
                      color: "primary",
                      size: "24px"
                    })
                  ]),
                  _: 1
                }, 8, ["aria-expanded"]),
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("b", null, _toDisplayString(_ctx.model &&
                "static_data" in _ctx.model &&
                _ctx.model.static_data["aantal_bronhouders"]), 1)
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card_section, null, {
                      default: _withCtx(() => [
                        (_ctx.model && 'static' in _ctx.model)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              innerHTML: _ctx.model.static['animatie-graph-bronhouders']
                            }, null, 8, _hoisted_5))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_expansion_item, {
              id: "expansion-item-aantal-registraties",
              modelValue: _ctx.aantalRegistratiesExpanded,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.aantalRegistratiesExpanded) = $event))
            }, {
              header: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  avatar: "",
                  role: "button",
                  "aria-expanded": _ctx.aantalRegistratiesExpanded.toString(),
                  "aria-label": "Open"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "bar_chart",
                      color: "primary",
                      size: "24px"
                    })
                  ]),
                  _: 1
                }, 8, ["aria-expanded"]),
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("b", null, _toDisplayString(_ctx.model &&
                "static_data" in _ctx.model &&
                _ctx.model.static_data["aantal_registraties"]), 1)
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card_section, null, {
                      default: _withCtx(() => [
                        (_ctx.model && 'static' in _ctx.model)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              innerHTML: _ctx.model.static['registratieobjecten-afgelopenweek-staaf']
                            }, null, 8, _hoisted_8))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_expansion_item, {
              id: "expansion-item-uitgelicht",
              modelValue: _ctx.gldExpanded,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.gldExpanded) = $event))
            }, {
              header: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  avatar: "",
                  role: "button",
                  "aria-expanded": _ctx.gldExpanded.toString(),
                  "aria-label": "Open"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "table_view",
                      color: "primary",
                      size: "24px"
                    })
                  ]),
                  _: 1
                }, 8, ["aria-expanded"]),
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("b", null, _toDisplayString(_ctx.model &&
                "static_data" in _ctx.model &&
                _ctx.model.static_data["aantal_glds"]), 1)
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card_section, null, {
                      default: _withCtx(() => [
                        (_ctx.model && 'static' in _ctx.model)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              innerHTML: _ctx.model.static['glds-week']
                            }, null, 8, _hoisted_11))
                          : _createCommentVNode("", true),
                        _hoisted_12,
                        (_ctx.model && 'static' in _ctx.model)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              innerHTML: _ctx.model.static['glds-top-20']
                            }, null, 8, _hoisted_13))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_separator, { class: "divider" }),
            _hoisted_14,
            _createVNode(_component_q_expansion_item, {
              id: "expansion-item-registratieobjecten-gemeenten",
              modelValue: _ctx.gemeentenExpanded,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.gemeentenExpanded) = $event))
            }, {
              header: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  avatar: "",
                  role: "button",
                  "aria-expanded": _ctx.gemeentenExpanded.toString(),
                  "aria-label": "Open"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "map",
                      color: "primary",
                      size: "24px"
                    })
                  ]),
                  _: 1
                }, 8, ["aria-expanded"]),
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("b", null, _toDisplayString(_ctx.model &&
                "static_data" in _ctx.model &&
                _ctx.model.static_data["aantal_gemeenten"][0]), 1)
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card_section, null, {
                      default: _withCtx(() => [
                        (_ctx.model && 'static' in _ctx.model)
                          ? (_openBlock(), _createBlock(_component_base_map_svg, {
                              key: 0,
                              bronhouderType: "Gemeente",
                              headerVariable: "gemeenten",
                              geojsonFile: "gemeentegrenzen.json",
                              overlayMode: "objecttypen",
                              staticContent: _ctx.model.static,
                              dataTypen: _ctx.model.static_data['data_gemeente_typen'],
                              dataRegimes: _ctx.model.static_data['data_gemeente_regimes']
                            }, null, 8, ["staticContent", "dataTypen", "dataRegimes"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _hoisted_16
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_expansion_item, {
              id: "expansion-item-registratieobjecten-provincies",
              modelValue: _ctx.provinciesExpanded,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.provinciesExpanded) = $event))
            }, {
              header: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  avatar: "",
                  role: "button",
                  "aria-expanded": _ctx.provinciesExpanded.toString(),
                  "aria-label": "Open"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "map",
                      color: "primary",
                      size: "24px"
                    })
                  ]),
                  _: 1
                }, 8, ["aria-expanded"]),
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("b", null, _toDisplayString(_ctx.model &&
                "static_data" in _ctx.model &&
                _ctx.model.static_data["aantal_provincies"][0]), 1)
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card_section, null, {
                      default: _withCtx(() => [
                        (_ctx.model && 'static' in _ctx.model)
                          ? (_openBlock(), _createBlock(_component_base_map_svg, {
                              key: 0,
                              class: "bromonitor-element",
                              bronhouderType: "Provincie",
                              headerVariable: "provincies",
                              geojsonFile: "provinciegrenzen.json",
                              overlayMode: "objecttypen",
                              staticContent: _ctx.model.static,
                              dataTypen: _ctx.model.static_data['data_provincie_typen'],
                              dataRegimes: _ctx.model.static_data['data_provincie_regimes']
                            }, null, 8, ["staticContent", "dataTypen", "dataRegimes"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _hoisted_18
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_expansion_item, {
              id: "expansion-item-registratieobjecten-waterschappen",
              modelValue: _ctx.waterschappenExpanded,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.waterschappenExpanded) = $event))
            }, {
              header: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  avatar: "",
                  role: "button",
                  "aria-expanded": _ctx.waterschappenExpanded.toString(),
                  "aria-label": "Open"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "map",
                      color: "primary",
                      size: "24px"
                    })
                  ]),
                  _: 1
                }, 8, ["aria-expanded"]),
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("b", null, _toDisplayString(_ctx.model &&
                "static_data" in _ctx.model &&
                _ctx.model.static_data["aantal_waterschappen"][0]), 1)
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card_section, null, {
                      default: _withCtx(() => [
                        (_ctx.model && 'static' in _ctx.model)
                          ? (_openBlock(), _createBlock(_component_base_map_svg, {
                              key: 0,
                              bronhouderType: "Waterschap",
                              headerVariable: "waterschappen",
                              geojsonFile: "waterschapsgrenzen.json",
                              overlayMode: "objecttypen",
                              staticContent: _ctx.model.static,
                              dataTypen: _ctx.model.static_data['data_waterschap_typen'],
                              dataRegimes: _ctx.model.static_data['data_waterschap_regimes']
                            }, null, 8, ["staticContent", "dataTypen", "dataRegimes"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_separator, { class: "divider" }),
            _hoisted_20,
            _createVNode(_component_q_expansion_item, {
              id: "expansion-item-top-20",
              modelValue: _ctx.top20Expanded,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.top20Expanded) = $event))
            }, {
              header: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  avatar: "",
                  role: "button",
                  "aria-expanded": _ctx.top20Expanded.toString(),
                  "aria-label": "Open"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "table_view",
                      color: "primary",
                      size: "24px"
                    })
                  ]),
                  _: 1
                }, 8, ["aria-expanded"]),
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card_section, null, {
                      default: _withCtx(() => [
                        (_ctx.model && 'static' in _ctx.model)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              innerHTML: _ctx.model.static['top20-registratieobjecten']
                            }, null, 8, _hoisted_22))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _hoisted_23
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_expansion_item, {
              id: "expansion-item-trends",
              modelValue: _ctx.trendsExpanded,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.trendsExpanded) = $event))
            }, {
              header: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  avatar: "",
                  role: "button",
                  "aria-expanded": _ctx.trendsExpanded.toString(),
                  "aria-label": "Open"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "timeline",
                      color: "primary",
                      size: "24px"
                    })
                  ]),
                  _: 1
                }, 8, ["aria-expanded"]),
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card_section, null, {
                      default: _withCtx(() => [
                        _hoisted_25,
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.optionSelected) = $event)),
                            name: "select-trends",
                            class: "select-trends",
                            onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.changedObjecttype && _ctx.changedObjecttype(...args)))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trendOptions, (opt) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: opt.value,
                                value: opt.value
                              }, _toDisplayString(opt.label), 9, _hoisted_28))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, _ctx.optionSelected]
                          ])
                        ]),
                        (_ctx.model && 'static' in _ctx.model && _ctx.model.static[_ctx.optionSelected])
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              innerHTML: _ctx.model.static[_ctx.optionSelected]
                            }, null, 8, _hoisted_29))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _hoisted_30
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_expansion_item, {
              id: "expansion-item-stand",
              modelValue: _ctx.standExpanded,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.standExpanded) = $event))
            }, {
              header: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  avatar: "",
                  role: "button",
                  "aria-expanded": _ctx.standExpanded.toString(),
                  "aria-label": "Open"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "bar_chart",
                      color: "primary",
                      size: "24px"
                    })
                  ]),
                  _: 1
                }, 8, ["aria-expanded"]),
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _hoisted_31
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("b", null, _toDisplayString(_ctx.model &&
                "static_data" in _ctx.model &&
                _ctx.model.static_data["totaal_aantal_objecten"]), 1)
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card_section, null, {
                      default: _withCtx(() => [
                        (_ctx.model && 'static' in _ctx.model)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              innerHTML: _ctx.model.static['registratieobjecten-staaf']
                            }, null, 8, _hoisted_32))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _hoisted_33
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_q_expansion_item, {
              id: "expansion-item-trends",
              modelValue: _ctx.actualiteitExpanded,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.actualiteitExpanded) = $event))
            }, {
              header: _withCtx(() => [
                _createVNode(_component_q_item_section, {
                  avatar: "",
                  role: "button",
                  "aria-expanded": _ctx.actualiteitExpanded.toString(),
                  "aria-label": "Open"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "source",
                      color: "primary",
                      size: "24px"
                    })
                  ]),
                  _: 1
                }, 8, ["aria-expanded"]),
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _hoisted_34
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card_section, null, {
                      default: _withCtx(() => [
                        (_ctx.model && 'static' in _ctx.model)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              innerHTML: _ctx.model.static['actualiteit']
                            }, null, 8, _hoisted_35))
                          : _createCommentVNode("", true),
                        _hoisted_36
                      ]),
                      _: 1
                    }),
                    _hoisted_37
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("img", {
                style: {"width":"48px !important"},
                alt: "BRO Logo",
                src: require('@/assets/bro_logo.png')
              }, null, 8, _hoisted_39)
            ])
          ]))
        : _createCommentVNode("", true),
      (
      _ctx.loaded &&
      _ctx.model &&
      'html' in _ctx.model &&
      (_ctx.urlContainsDate() || _ctx.is_empty(_ctx.model.html))
    )
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_41, [
                (!_ctx.isOldestMonitor())
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "#",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.previousMonitor()))
                    }, " < vorige "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_42, " vorige ")),
                _createTextVNode(" | "),
                _createVNode(_component_router_link, { to: { name: 'bro-monitor-archive' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(" naar archief ")
                  ]),
                  _: 1
                }),
                _createTextVNode(" | "),
                (!_ctx.isMostRecentMonitor())
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      href: "#",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.nextMonitor()))
                    }, " volgende >"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_43, " volgende"))
              ]),
              (_ctx.model && 'html' in _ctx.model)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    id: "archive-monitor",
                    innerHTML: _ctx.model.html,
                    ref: "monitor-html",
                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
                  }, null, 8, _hoisted_44))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_q_page_sticky, {
        position: "bottom-right",
        offset: [18, 18]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_btn, {
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.toTop())),
            icon: "vertical_align_top",
            "aria-label": "Ga naar de bovenkant van de pagina",
            color: "primary",
            fab: ""
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, _ctx.scY > 150]
      ])
    ]),
    _: 1
  }))
}